import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import Swal from "sweetalert2";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUtensils } from "@fortawesome/free-solid-svg-icons";

const List = ({ allowMMargin = -true }) => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const formatBdTime = (timeValue) => {
    if (!timeValue) return "";
    if (typeof timeValue === "string" && /am|pm/i.test(timeValue)) {
      return timeValue;
    }
    const raw = String(timeValue).trim();
    const match = raw.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
    if (!match) return raw;
    let hours = parseInt(match[1], 10);
    const minutes = match[2];
    const suffix = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    if (hours === 0) hours = 12;
    return `${hours}:${minutes} ${suffix}`;
  };

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/requisition-production`);
      const resRole = await Http.get(`/staff-type-check`);
      setReceiveData(res.data.list);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data.list);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  const receiveItem = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, receive it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post("/receive-requisition-production/" + id).then((res) => {
          setReceiveData(res.data.list);
          Swal.fire("Received!", "Item has been received.", "success");
        });
      }
    });
  };
  const cols = [
    { field: "date", header: "Date" },
    { field: (item) => formatBdTime(item.time), header: "Time" },
    // { field: "product.name", header: "Finished Good" },
    // { field: "batch_size", header: "Batch Size" },
    {
      // field: "receive",
      header: "status",
      field: (item) =>
        // role === "gm" ? (
        //   item.approved_by ? (
        //     <span className="text-center">
        //       Approved
        //     </span>
        //   ) : (
        //     <span
        //       className="badge bg-success p-2 rounded ms-1 text-center cursor-pointer"
        //       role="button"
        //       onClick={() => approveRequisition(item.id)}
        //     >
        //       Approve
        //     </span>
        //   )
        // ) : (
        item.approved_by ? (
          item?.issue ? (
            <span className="text-center">
              {item?.issue?.rmpm_receive_status == 1 ? (
                "Production Received The Item"
              ) : (
                <>
                  {role !== "production" &&
                    "Store Released waiting for Production Receive"}
                  {role == "production" && (
                    <span
                      onClick={() => receiveItem(item.id)}
                      className="badge bg-primary p-2 rounded ms-1 cursor-pointer"
                      role="button"
                    >
                      (Click to Confirm Received)
                    </span>
                  )}
                </>
              )}
            </span>
          ) : (
            <span className="text-center">
              {role !== "supply_chain" &&
                " Approved By GM And Waiting for Store Release  "}

              {item.issue == null &&
                role !== "gm" &&
                role == "supply_chain" && (
                  <Link
                    to={{
                      pathname: "/create-issue/" + item.id,
                    }}
                    className="btn btn-primary btn-sm"
                  >
                    Release
                  </Link>
                )}
            </span>
          )
        ) : (
          <span className="text-muted">
            {role !== "gm" && " Requested to GM "}
            {role == "gm" && (
              <span
                className="badge bg-success p-2 rounded ms-1 text-center cursor-pointer"
                role="button"
                onClick={() => approveRequisition(item.id)}
              >
                Approve
              </span>
            )}
          </span>
        ),
      // )
    },
    // { field: "expected_production_date", header: "Expected Production Date" },
    { field: "created_by.name", header: "Created by" },
  ];

  const actionTemplate = (item, deleteData) => {
    return (
      <td className="text-xs">
        {/* {(item.issue !== null && item?.issue?.rmpm_receive_status !== 1) && role == 'production' ? (
          <button
            className="btn btn-success btn-sm ms-1" title="Approve if you have received the item"
            onClick={() =>
              receiveItem(
                item.id
              )
            }
          >
            <i className="fa fa-check" aria-hidden="true"></i>
          </button>
        ) : (
          (item?.issue?.rmpm_receive_status == 1) && <span title="Item Received" className="text-success ms-2"><i className="fa fa-check-circle fa-2x" aria-hidden="true"></i></span>
        )} */}
        {/* {item.issue == null && role !== "gm" && role == 'supply_chain' ? (
          <Link
            to={{
              pathname: "/create-issue/" + item.id,
            }}
            className="btn btn-primary btn-sm"
          >
            Release
          </Link>
        ) : (
          ""
        )} */}
        <Link
          to={{
            pathname: "/requisition-production-view/" + item.id,
          }}
          className="btn btn-info btn-sm ms-1"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>
        {item.issue == null && role !== "gm" && !item.approved_by ? (
          <Link
            to={{
              pathname: "/edit-requisition-production/" + item.id,
            }}
            className="btn btn-secondary btn-sm ms-1"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Link>
        ) : (
          ""
        )}
        {item.issue == null && role !== "gm" && !item.approved_by ? (
          <button
            className="btn btn-danger btn-sm ms-1"
            onClick={() =>
              deleteData(
                item.id,
                "requisition-production",
                "Requisition Production",
              )
            }
          >
            <i className="fa fa-trash"></i>
          </button>
        ) : (
          ""
        )}
        {/* {item.requisition_status == 'active' && ( */}
        {/* <Link
          to={{
            pathname: "/create-production-by-requisition/" + item.id,
          }}
          className="btn btn-primary btn-sm ms-1"
        >
          <FontAwesomeIcon icon={faUtensils} style={{ color: "#ffffffff" }} />
        </Link> */}
        {/* )} */}
      </td>
    );
  };

  const approveRequisition = (id) => {
    if (role !== "gm") {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to approve this requisition production?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post("/approve-requisition-production/" + id).then((res) => {
          setReceiveData(res.data.list);
          Swal.fire(
            "Approved!",
            "Requisition Production has been approved.",
            "success",
          );
        });
      }
    });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className={`${allowMMargin ? "am-mainpanel " : ""}`}>
          <div className="am-pagetitle">
            <h5 className="am-title">All Requisition Production</h5>
            {role == "production" && (
              <Link
                to="/create-requisition-production"
                className="btn btn-primary"
              >
                <i className="fa fa-plus-square mg-r-6"></i>New
              </Link>
            )}
          </div>

          <div className={` ${allowMMargin ? "am-pagebody" : ""}`}>
            <Alert alert={alert} />

            <div className={`${allowMMargin ? "card pd-20 pd-sm-40" : "p-0"}`}>
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
